module.exports = __webpack_public_path__ + "img/Blue.b4651df5.jpg";